import { render, staticRenderFns } from "./MessageListHeader.vue?vue&type=template&id=7ac3a27c"
import script from "./MessageListHeader.vue?vue&type=script&lang=js"
export * from "./MessageListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports